(function() {
    angular
        .module('ngmvac')
        .controller('CouponController', CouponController);

    CouponController.$inject = ['PaymentFactory'];

    function CouponController(PaymentFactory) {
        var vm = this;

        vm.setCoupon = function() {
            swal({
                title: 'Cupon',
                text: 'Inserte el cupon',
                type: 'input',
                showCancelButton: true, 
                closeOnConfirm: false,
                animation: 'slide-from-top',
                inputPlaceholder: 'Inserte su cupon aqui',
                //showLoaderOnConfirm: true
            }, function(inputValue) {
                if (inputValue === false) return false;

                if (inputValue === '') {
                    swal.showInputError('No ha insertado ningun cupon.');
                }

                PaymentFactory.validaCupon(inputValue)
                    .then(function(response) {

                    }).catch(function(err) {

                    });
            });
        }
    }
})();